import React from "react";
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button
} from "reactstrap";

const MessageDialog = ({
    isOpen,
    message,
    onConfirm,
    buttonText = "OK"
}) => {
    return (
        <Modal
            isOpen={isOpen}
            centered
            backdrop="static"
            keyboard={false}
        >
            <ModalBody
                className="text-center"
                style={{
                    paddingTop: "50px",
                    paddingBottom: "20px",
                    fontSize: "18px",
                    lineHeight: "1.6"
                }}
            >
                {message}
            </ModalBody>

            <ModalFooter
                className="justify-content-center"
                style={{
                    borderTop: "none"
                }}
            >
                <Button
                    color="link"
                    onClick={onConfirm}
                    style={{
                        fontWeight: "bold",
                        color: "#000"
                    }}
                >
                    {buttonText}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default MessageDialog;